<template>
	<div v-if="!hasNoAddressData" class="w-full text-sm text-ihh-midnight-gray flex justify-center items-center pr-2">
		<div class="w-full">
			<div class="space-x-0.5">
				<span>{{ address?.firstName }}</span>
				<span>{{ address?.lastName }}</span>
			</div>
			<span>{{ formattedPhone }}</span>
			<div>{{ address?.company }}</div>
			<div>{{ address?.address1 }}</div>
			<div v-if="address?.address2">{{ address?.address2 }}</div>
			<div class="space-x-1">
				<span>{{ address?.city }},</span>
				<span>{{ address?.stateOrProvince }},</span>
				<span>{{ address?.postalCode }}</span>
				<span>/ {{ address?.countryCode }}</span>
			</div>

			<div v-if="isShipping && !!shippingMethod" class="">
				<div class="border-b my-3"></div>
				<div>
					<div class="flex w-full items-center space-x-2">
						<div class="">{{ format() }}</div>
						<div>-</div>
						<div class="flex font-semibold">
							{{ shippingMethod?.cost.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import helpers from '../../helpers/checkout.js'

export default {
	name: 'AddressSummary',
	props: {
		address: {
			type: Object,
		},
		type: {
			type: String,
			default: 'billing',
		},
		shippingMethod: {
			type: Object,
			default: null,
		},
	},
	data() {
		return {}
	},
	methods: {
		format() {
			return helpers.formatShippingDescription(this.shippingMethod?.description, false)
		},
	},

	computed: {
		isShipping() {
			return this.type === 'shipping'
		},
		formattedPhone() {
			const phone = this.address?.phone || ''
			const digits = phone.replace(/\D/g, '') // Remove non-numeric characters
			return digits.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3') // Format as 512-555-5555
		},
		hasNoAddressData() {
			if (!this.address) return true

			// Loop through all address fields to check if any are truthy
			for (const field in this.address) {
				if (this.address[field]) {
					return false // At least one field has a value
				}
			}

			// If we get here, no fields were truthy
			return true
		},
	},
}
</script>

<style scoped></style>
